import { Outlet } from 'react-router';

import { AppLayout } from '#src/components/navigation/AppLayout/index.tsx';

const FavoritesWatchlistLayout = () => {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

export default FavoritesWatchlistLayout;
